// src/components/AzioniRapide.js
import React from 'react';
import { Box, Typography, Button, Grid, Dialog, DialogContent } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import TableBarIcon from '@mui/icons-material/TableBar';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalTavolo from '../pages/ModalTavolo';
import { t } from 'i18next';
import SelezioneComanda from '../pages/SelezionaComande';
import { getTenantTranslation } from '../utils/getTenantTranslation';


const AzioniRapide = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const navigate = useNavigate();
  const [openTavolo, setOpenTavolo] = useState(false);
  const [openComanda, setOpenComanda] = useState(false);
  const tenantType = localStorage.getItem('tenantType');
  const isConferenceTenant = String(tenantType || '').toUpperCase() === 'SALE_CONGRESSI';


  const getButtonStyle = (colorKey) => {
    const darkColors = {
      blue: 'var(--Elements-Blue, #549AEF)',
      red: 'var(--Elements-Red, #FF8C8C)',
      green: 'var(--Elements-Green, #78BD6A)',
    };

    const lightColors = {
      blue: '#0052cc',
      red: '#d32f2f',
      green: '#2e7d32',
    };

    const backgroundColor = isDarkMode ? darkColors[colorKey] : lightColors[colorKey];

    return {
      backgroundColor,
      color: '#fff',
      borderRadius: 'var(--borderRadius, 4px)',
      '&:hover': {
        opacity: 0.9,
        backgroundColor: theme.palette.customPagination.secondary, //temporaneo
      }
    };
  };

  // const outlinedButtonStyle = {
  //   borderRadius: '8px',
  //   border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.60)' : 'rgba(0, 0, 0, 0.25)'}`,
  //   background: isDarkMode ? '#1C1C1C' : '#D8D8D8',
  //   color: isDarkMode ? '#FFFFFF' : '#131313',
  //   '&:hover': {
  //     background: isDarkMode ? '#2a2a2a' : '#e0e0e0',
  //   },
  // };

  const openCongressPractice = () => {
    window.dispatchEvent(new CustomEvent('open_congress_practice'));
    navigate('/prenotazione', { state: { openPractice: true } });
  };

  return (
    <>
      <Box
        sx={{
          // marginTop: 3,
          border: '1px solid #CCC',
          borderRadius: '8px',
          padding: '1.719vw',
          backgroundColor: theme.palette.background.paper,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {t("quickActions.quickActions")}
        </Typography> */}

        <Grid container spacing={2}>
          <Grid item xs={isConferenceTenant ? 12 : 3} sm={isConferenceTenant ? 12 : 3} md={isConferenceTenant ? 12 : 3} lg={isConferenceTenant ? 12 : 3} xl={isConferenceTenant ? 12 : 3} sx={{ width: "100%" }}>
            <Button
              fullWidth
              startIcon={isConferenceTenant ? null : <AddIcon />}
              sx={getButtonStyle('blue')}
              onClick={isConferenceTenant ? openCongressPractice : () => setOpenComanda(true)}
            >
              <Typography sx={{fontSize: 10, textWrap: "nowrap",}}>{getTenantTranslation(t, tenantType, "newOrder")}</Typography>
            </Button>
          </Grid>
          {!isConferenceTenant && (
            <>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3} sx={{ width: "100%" }}>
                <Button
                  fullWidth
                  startIcon={<PointOfSaleIcon />}
                  sx={getButtonStyle('red')}
                  onClick={() => navigate('/punto_cassa')}
                >
                  <Typography sx={{fontSize: 10, textWrap: "nowrap",}}>{t("quickActions.closeOrder")}</Typography>
                </Button>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3} >
                <Button
                  fullWidth
                  startIcon={<TableBarIcon />}
                  sx={getButtonStyle('green')}
                  onClick={() => setOpenTavolo(true)}
                >
                  <Typography sx={{fontSize: 10, textWrap: "nowrap",}}>{getTenantTranslation(t, tenantType, 'addTable')}</Typography>
                </Button>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3} >
                <Button
                  fullWidth
                  startIcon={<Inventory2Icon />}
                  sx={getButtonStyle('blue')}
                  onClick={() => navigate('/lista_prodotti')}
                >
                  <Typography sx={{fontSize: 10, textWrap: "nowrap",}}>{getTenantTranslation(t, tenantType, 'products')}</Typography>
                </Button>
              </Grid>
            </>
          )}
        </Grid>
{/* 
        <Typography variant="subtitle1" sx={{ mt: 4, mb: 2 }}>
          {t("quickActions.directAccess")}
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Button fullWidth variant="outlined" startIcon={<PointOfSaleIcon />} sx={outlinedButtonStyle}>
              {t("quickActions.cashRegister")}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button fullWidth variant="outlined" onClick={() => navigate('/menu')} startIcon={<MenuIcon />} sx={outlinedButtonStyle}>
              {t("menu")}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button fullWidth variant="outlined" startIcon={<HelpOutlineIcon />} sx={outlinedButtonStyle}>
              {t("support")}
            </Button>
          </Grid>
        </Grid> */}

      </Box>

      {openComanda && (
        // <ModalComanda
        //   open={openComanda}
        //   onClose={() => setOpenComanda(false)}
        // />
        <Dialog
          open={openComanda}
          fullWidth
          maxWidth={false}
          PaperProps={{
            sx: {
              width: { xs: '100vw', md: '95vw' },
              maxWidth: '1800px',
              height: { xs: '100dvh', md: 'auto' },
              maxHeight: { xs: '100dvh', md: 'calc(100dvh - 32px)' },
              m: { xs: 0, md: 2 },
              borderRadius: { xs: 0, md: 2 },
              overflow: 'hidden',
            },
          }}
          onClose={() => setOpenComanda(false)}
        >
          <DialogContent sx={{
            paddingBottom: 0,
            paddingTop: 0,
            minHeight: 0,
            overflowY: 'hidden',
            overflowX: 'hidden',
            touchAction: 'pan-x pan-y pinch-zoom',
            WebkitOverflowScrolling: 'touch',
          }}>
            <SelezioneComanda
              open={openComanda}
              tavolo={null}
              onClose={() => setOpenComanda(false)}
            />
          </DialogContent>
        </Dialog>
      )}

      {openTavolo && (
        <ModalTavolo
          open={openTavolo}
          onClose={() => { setOpenTavolo(false) }}
        />
      )}
    </>
  );
};

export default AzioniRapide;
